import { render } from "./AddButton.vue?vue&type=template&id=766a01e2&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=766a01e2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766a01e2"],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/FaultComponents/SystemSelfCheckComponents/AddButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "766a01e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('766a01e2', __exports__)) {
    api.reload('766a01e2', __exports__)
  }
  
  module.hot.accept("./AddButton.vue?vue&type=template&id=766a01e2&scoped=true", () => {
    api.rerender('766a01e2', render)
  })

}


export default __exports__